import React from "react";
import { authHeader, redirectToFusionLogin } from "./auth";

class APIService extends React.Component {
  constructor(props) {
    super(props);
    this.baseAPIURL =
      props.baseAPIURL || `${process.env.REACT_APP_ADMIN_HOST}/api/driver/`;
  }

  getRequest({ path, method = "GET", headers = {} }) {
    const url = this.baseAPIURL + path;
    return fetch(url, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      headers: {
        ...authHeader(),
        ...headers,
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      credentials: "same-origin",
    })
      .then(async (res) => {
        if (res.status === 401) {
          redirectToFusionLogin();
          throw new Error("Unauthenticated");
        }

        const body = await res.json();
        if (!res.ok) {
          const error = new Error(
            body?.message || `Request failed with status ${res.status}`
          );
          error.status = res.status;
          error.response = body;
          throw error;
        }
        return body;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error instanceof Error ? error : new Error(`${error}`);
      });
  }

  postRequest({ path, method = "POST", headers = {}, data = {} }) {
    const url = this.baseAPIURL + path;
    return fetch(url, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      headers: {
        ...authHeader(),
        ...headers,
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *client
      credentials: "same-origin",
      body: data,
    })
      .then(async (res) => {
        if (res.status === 401) {
          redirectToFusionLogin();
          throw new Error("Unauthenticated");
        }

        const body = await res.json();

        const locked =
          body?.data?.code === "COLLECTION_LOCKED" ||
          body?.code === "COLLECTION_LOCKED";

        if (locked) {
          const error = new Error(
            body?.data?.message ||
              body?.message ||
              "This collection has already been submitted."
          );
          error.code = body?.data?.code || body?.code;
          error.response = body;
          error.status = res.status;
          throw error;
        }

        if (!res.ok) {
          const error = new Error(
            body?.message || `Request failed with status ${res.status}`
          );
          error.code = body?.code || "REQUEST_FAILED";
          error.response = body;
          error.status = res.status;
          throw error;
        }

        return body;
      })
      .catch((error) => {
        console.error("Error:", error);
        throw error instanceof Error ? error : new Error(`${error}`);
      });
  }

  async getCollections(uid) {
    return this.getRequest({
      path: "collections/" + uid,
      method: "GET",
      headers: {},
    });
  }

  async postCollection(uid, data) {
    return this.postRequest({
      path: "collection/" + uid,
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: JSON.stringify(data),
    });
  }

  async postDisposal(data) {
    return this.postRequest({
      path: "disposal",
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: JSON.stringify(data),
    });
  }

  async getStock() {
    return this.getRequest({
      path: "stock",
      method: "GET",
      headers: {},
    });
  }

  async getDrivers() {
    return this.getRequest({
      path: "drivers",
      method: "GET",
      headers: {},
    });
  }
}

export default new APIService({
  baseAPIURL: `${process.env.REACT_APP_ADMIN_HOST}/api/driver/`,
});
